import { useTranslation } from "react-i18next";import React from 'react';
import { Card, CardContent } from '@/shared/components/ui/card';
import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import {
  Thermometer,
  Battery,
  Wifi,
  WifiOff,
  AlertTriangle,
  Link as LinkIcon,
  Settings } from
'lucide-react';

export const SensorCard = ({ sensor, onBind, onConfigure }) => {const { t } = useTranslation("ezparcel");
  const statusColors = {
    'Active': 'bg-emerald-100 text-emerald-700',
    'Warning': 'bg-amber-100 text-amber-700',
    'Offline': 'bg-gray-100 text-gray-700',
    'Critical': 'bg-red-100 text-red-700'
  };

  const getBatteryColor = (level) => {
    if (level > 50) return 'text-emerald-600';
    if (level > 20) return 'text-amber-600';
    return 'text-red-600';
  };

  const getBatteryIcon = (level) => {
    if (level > 75) return '████';
    if (level > 50) return '███░';
    if (level > 25) return '██░░';
    if (level > 10) return '█░░░';
    return '░░░░';
  };

  return (
    <Card className="card-elevated hover:shadow-lg transition-all">
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${
            sensor.status === 'Active' ? 'bg-cyan-100' :
            sensor.status === 'Warning' ? 'bg-amber-100' : 'bg-gray-100'}`
            }>
              <Thermometer className={`h-5 w-5 ${
              sensor.status === 'Active' ? 'text-cyan-600' :
              sensor.status === 'Warning' ? 'text-amber-600' : 'text-gray-600'}`
              } />
            </div>
            <div>
              <p className="font-medium">{sensor.name}</p>
              <p className="text-xs text-muted-foreground font-mono">{sensor.serialNumber}</p>
            </div>
          </div>
          <Badge className={statusColors[sensor.status]}>
            {sensor.status === 'Active' && <Wifi className="h-3 w-3 mr-1" />}
            {sensor.status === 'Offline' && <WifiOff className="h-3 w-3 mr-1" />}
            {sensor.status === 'Warning' && <AlertTriangle className="h-3 w-3 mr-1" />}
            {sensor.status}
          </Badge>
        </div>

        {/* Current Reading */}
        {sensor.lastReading &&
        <div className="bg-muted/30 rounded-lg p-3 mb-3">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-muted-foreground">{t("temperature", "Temperature")}</p>
                <p className="text-2xl font-bold font-mono text-cyan-600">
                  {(sensor.lastReading?.temp ?? 0).toFixed(1)}{t("c", "\xB0C")}
              </p>
              </div>
              {sensor.lastReading?.humidity &&
            <div className="text-right">
                  <p className="text-xs text-muted-foreground">{t("humidity", "Humidity")}</p>
                  <p className="text-lg font-medium">
                    {sensor.lastReading.humidity}%
                  </p>
                </div>
            }
            </div>
            <p className="text-xs text-muted-foreground mt-2">{t("lastReading", "Last reading:")}
            {new Date(sensor.lastReading.timestamp).toLocaleString()}
            </p>
          </div>
        }

        {/* Battery & Type */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Battery className={`h-4 w-4 ${getBatteryColor(sensor.batteryLevel)}`} />
            <span className={`font-mono text-sm ${getBatteryColor(sensor.batteryLevel)}`}>
              {getBatteryIcon(sensor.batteryLevel)} {sensor.batteryLevel}%
            </span>
          </div>
          <Badge variant="outline">{sensor.type}</Badge>
        </div>

        {/* Assignment */}
        {sensor.assignedTo ?
        <div className="text-sm p-2 rounded bg-blue-50 dark:bg-blue-950/30 border border-blue-200">
            <p className="text-xs text-muted-foreground">{t("assignedTo", "Assigned to:")}</p>
            <p className="font-medium text-blue-700 dark:text-blue-300">
              {sensor.assignedTo.name}
            </p>
            <p className="text-xs text-muted-foreground capitalize">
              {sensor.assignedTo.type}: {sensor.assignedTo.id}
            </p>
          </div> :

        <div className="text-sm p-2 rounded bg-gray-50 dark:bg-gray-950/30 border border-gray-200 text-center">
            <p className="text-muted-foreground">{t("notAssigned", "Not assigned")}</p>
          </div>
        }

        {/* Actions */}
        <div className="flex gap-2 mt-3">
          <Button
            variant="outline"
            size="sm"
            className="flex-1 gap-1"
            onClick={() => onBind?.(sensor)}>
            
            <LinkIcon className="h-3 w-3" />
            {sensor.assignedTo ? 'Rebind' : 'Bind'}
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="flex-1 gap-1"
            onClick={() => onConfigure?.(sensor)}>
            
            <Settings className="h-3 w-3" />{t("configure", "Configure")}

          </Button>
        </div>
      </CardContent>
    </Card>);

};